export const DISTANCE_UNITS_MAP = {
  'au': 'km',
  'gb': 'miles',
  'us': 'miles',
  'nz': 'km',
  'ie': 'km',
  'ca': 'km'
};

export const MORE_FILTERS = [
  { id: 'contractTerms', value: 'Contract term' },
  { id: 'contractTypes', value: 'Contract type' },
  { id: 'agePhases', value: 'Ages' },
  { id: 'ageRange', value: 'Age range' },
  { id: 'experiences', value: 'Experiences' },
  { id: 'timing', value: 'Timing' }
];

export const getExperimentsArray = (experiments, { query, cookies }) => {
  const experiment = Object.assign({}, experiments.assignmentFor(cookies));
  return Object.keys(experiment).reduce((acc, key) => {
    if (key.indexOf('job_') !== 0) return acc;
    return query[key] ? [...[`${key}=${query[key]}`], ...acc] : [...[`${key}=${experiment[key]}`], ...acc];
  }, []);
};

export const maxDistanceForCountry = (maxDistance, country) => {
  const THIRTY_MILES = 5;
  const FIFTY_KM = 6;
  if (maxDistance === -1) return (country === 'gb' || country === 'us') ? THIRTY_MILES : FIFTY_KM;
  return maxDistance;
};

export const PARAM_PAGE = 'currentpage';

export const updateQS = (uri, k, v) => {
  const re = new RegExp(`([?&])${k}=.*?(&|$)`, 'i');
  const sep = uri.indexOf('?') !== -1 ? '&' : '?';
  return uri.match(re) ?
    uri.replace(re, `$1${k}=${v}$2`) :
    `${uri}${sep}${k}=${v}`;
};

export const doParam = (n, v) => `${encodeURIComponent(n)}=${encodeURIComponent(v)}`;

export const encodeQueryString = params =>
  params.reduce((qs, { name, value }) => {
    Array.isArray(value) ?
      qs.push(encodeQueryString(value.map(v => ({ name, value: v })))) :
      qs.push(doParam(name, value));
    return qs;
  }, []).join('&');

export const jobSuffix = count => count === 1 ? 'job' : 'jobs';

export const getAvailableSiteCountry = (sc, { defaultCountry, siteCountries }) =>
  siteCountries.indexOf(sc) > -1 ? sc : defaultCountry;

export const removeURLParameter = (url, parameter) => {
  const urlparts = url.split('?');
  if (urlparts.length >= 2) {
    const prefix = `${encodeURIComponent(parameter)}=`;
    const pars = urlparts[1].split(/[&;]/g);
    for (let i = pars.length; i-- > 0;) {
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }
    return `${urlparts[0]}${(pars.length > 0 ? `?${pars.join('&')}` : '')}`;
  }
  return url;
};

export const selectedFlatter = (selectedArray) => {
  const result = [];
  selectedArray.forEach((selectedFacet) => {
    if (!Array.isArray(selectedFacet.value)) return result.push(selectedFacet);
    selectedFacet.value.forEach(value => {
      result.push(Object.assign({}, selectedFacet, { value }));
    });
  });
  return result;
};

export const removeURLParameters = (url, toRemove) =>
  Array.isArray(toRemove) ?
    toRemove.reduce((newUrl, currParam) => removeURLParameter(newUrl, currParam), url) :
    removeURLParameter(url, toRemove)
  ;

export const removeCurrentPage = url => url.replace(/(&|\?)?currentpage=\d+/, '');

export const remover = (str, part) => {
  const rx = new RegExp(part.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'ig');
  return str.replace(rx, '');
};

export const removeUrlPart = (url, _urlPart) => {
  const urlPart = encodeURIComponent(_urlPart);
  const index = url.toLowerCase().indexOf(urlPart.toLowerCase());
  if (url[index - 1] === '&') return remover(url, `&${urlPart}`);
  if (url[index + urlPart.length] === '&') return remover(url, `${urlPart}&`);
  return remover(url, `?${urlPart}`);
};

export const clearTagFromUrl = (url, { name, value }) => {
  const escapedValue = encodeURIComponent(value).replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
  const rx = new RegExp(`${name}=${escapedValue}($|&)`);
  return url.replace(rx, '');
};

export const clearAllFromUrl = (url, key) => {
  const rx = new RegExp(key + '(=[^&]*)?(&|$)');
  return url.replace(rx, '');
};

export const addDontMappFacet = (url, keyword) => (url.indexOf('?') > -1 ? url.concat(`&dontFacetKeyword=${keyword}`) : url.concat(`?dontFacetKeyword=${keyword}`));

export const getSelectedMoreFacets = (selectedFacets) => selectedFacets.filter(f => (MORE_FILTERS.find(elem => f.name === elem.id)));

export const buildNewQueryString = (k, v, qs) => updateQS(removeCurrentPage(qs || window.location.search), k, v);

export const getPaginatedHref = (url, page) => {
  const newUrl = removeCurrentPage(url);
  return ((!page || page === 1) ? newUrl : updateQS(newUrl, 'currentpage', page));
};

export const escapeSiteCountry = (siteCountry, countryOptions) => {
  if (countryOptions.siteCountries.indexOf(siteCountry) === -1) {
    return 'gb';
  }
  return siteCountry;
};

export const updateUrl = (qs, keywords) => {
  const maxDistance = document.querySelector('select#jobs-distance');
  let newUrl = removeCurrentPage(qs);

  const textInputs = {
    keywords: { value: keywords, disabled: false },
    locations: document.querySelector('input[name="locations"]'),
    point: document.querySelector('input[name="point"]'),
    bbox: document.querySelector('input[name="bbox"]'),
    displayLocation: document.querySelector('input[name="displayLocation"]')
  };

  const textValues = Object.entries(textInputs)
    .reduce((acc, [key, input]) => {
      if (input && !input.disabled) {
        return {
          ...acc,
          [key]: encodeURIComponent(input.value),
        };
      }

      return acc;
    }, {});

  Object.entries(textValues).forEach(([k, v]) => {
    newUrl = updateQS(newUrl, k, v);
  });

  if (!maxDistance.disabled && maxDistance.selectedIndex) {
    newUrl = updateQS(newUrl, 'maxdistance', encodeURIComponent(maxDistance.options[maxDistance.selectedIndex].value));
  }

  if (!textValues.locations && (textValues.point || textValues.bbox)) {
    newUrl = removeURLParameter(newUrl, 'locations');
  }

  return newUrl;
};

export const mzEmit = (data = {}, mzEvent = 'CLICK') => new Promise((res, rej) => {
  if (typeof window === 'undefined' || !window._mz) return rej(new Error('Trying to send mz without _mz on window'));
  window._mz.emit(window._mze[mzEvent] || mzEvent, data, res);
});

export { keywordHistory } from './keywordHistory';

export const removeTrailingSlash = (url) => url.replace(/\/$/, '');

export const link = ({ baseUrl, siteUrlPrefix }, linkUrl, relative) => {
  // console.trace();
  // console.log('link', { baseUrl, siteUrlPrefix, linkUrl, relative });
  const replaceBaseUrlRegEx = new RegExp('^' + baseUrl.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
  const relativeUrl = linkUrl.replace(replaceBaseUrlRegEx, '/').replace(/^\/+/, '/');
  const prefixedUrl = removeTrailingSlash(siteUrlPrefix) + relativeUrl;
  return relative ? prefixedUrl : removeTrailingSlash(baseUrl) + prefixedUrl;
};
